import { render, staticRenderFns } from "./view-asset-history.vue?vue&type=template&id=1a3b56cc&scoped=true&"
import script from "./view-asset-history.vue?vue&type=script&lang=ts&"
export * from "./view-asset-history.vue?vue&type=script&lang=ts&"
import style0 from "./view-asset-history.vue?vue&type=style&index=0&id=1a3b56cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3b56cc",
  null
  
)

export default component.exports